module.exports.version = 'v11.9.2-e37f08f6';
